import { render, staticRenderFns } from "./json-data-renderer.vue?vue&type=template&id=56fba1ef"
import script from "./json-data-renderer.vue?vue&type=script&lang=js"
export * from "./json-data-renderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports